import identity from '../../utils/identity';

const onCartUpdateSideEffects = ({ cart, list }, callback) => {
  const updateAccessors = window?.NikeShop?.set || identity;
  if (cart?.cart) {
    updateAccessors('cartItems', cart?.cart);
  }
  if (list?.listItems?.objects) {
    updateAccessors('listItems', list?.listItems?.objects);
  }

  if (callback) {
    callback({ cart, list });
  }
  return { cart, list };
};

export default onCartUpdateSideEffects;
